<template>
  <SoDialog
    v-model="value"
    :loading="false"
    width="1200"
    card-title="Smart Pay As You Go"
    data-testid="spayg-modal-dialog"
    @on-close="$emit('closeModal')"
  >
    <p class="mt-4" data-testid="spayg-modal-overview">
      Smart Pay As You Go is ideal if you prefer to pay for energy as you use
      it, want tighter control over your spending, and need more visibility of
      your energy costs.
    </p>

    <p class="mt-4">Benefits of SPAYG:</p>

    <div class="mt-4">
      <ul class="ml-8" data-testid="spayg-modal-benefits-list">
        <li>Track your energy spending in real-time</li>
        <li>Top up via the app or in your local shop</li>
        <li>Schedule automatic top-ups in the So Energy Smart Prepay App</li>
        <li>Choose payment amounts that work for you</li>
        <li>No more unexpected bills</li>
      </ul>
    </div>
    <div class="d-flex justify-end mt-8">
      <SoButton
        data-testid="spayg-modal-close-btn"
        type="secondary"
        title="Close"
        class="mr-2"
        large
        @click="$emit('closeModal')"
      />
      <SoButton
        data-testid="spayg-modal-quote-btn"
        type="primary"
        title="Quote & Switch"
        large
        @click="openSpayg"
      />
    </div>
  </SoDialog>
</template>
<script lang="ts">
  import { defineComponent } from "vue"
  import SoDialog from "@/components/SoDialog.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import { RouteNames } from "@/types/router"

  export default defineComponent({
    components: {
      SoDialog,
      SoButton,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
    },
    emits: ["update:modelValue", "closeModal"],
    data() {
      return {}
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
    },
    methods: {
      openSpayg() {
        this.$router.push({ name: RouteNames.CustomerSpayg })
      },
    },
  })
</script>
